import apiClient from "@/services/api/axiosConfig";
import { V3 } from "@/services/api/apiPrefix";

/**
 * FAIL-OPEN DELIBERADO: em qualquer erro devolve null, e o guard trata null
 * como "não bloquear". Um 500 ou queda de rede não pode prender o lojista
 * numa tela de onboarding da qual ele não consegue sair.
 */
async function request(call) {
  try {
    const { data } = await call();
    return data?.response ?? null;
  } catch (error) {
    console.error("❌ [OnboardingService] Erro ao consultar status:", error);
    return null;
  }
}

/**
 * Status do onboarding KYC (envio de selfie + documento ao Asaas).
 *
 * O backend (menuus-core-api, módulo asaas-onboarding) devolve um `state` já
 * traduzido e um `requiresAction` — este é o único campo que decide o redirect.
 * Não reimplemente a máquina de estados aqui: mudar a regra de bloqueio deve
 * ser mudança de backend apenas.
 */
export class OnboardingService {
  static async getStatus(pointOfSaleId) {
    if (!pointOfSaleId) return null;
    return request(() =>
      apiClient.get(`${V3}/business/onboarding/status/${pointOfSaleId}`),
    );
  }

  /** "Verificar agora" — reconciliação sob demanda, sempre por clique do usuário. */
  static async refresh(pointOfSaleId) {
    if (!pointOfSaleId) return null;
    return request(() =>
      apiClient.post(`${V3}/business/onboarding/refresh/${pointOfSaleId}`),
    );
  }
}

export default OnboardingService;
